<ng-container *ngIf="hero">
  <img class="hero" [src]="bucketURL + hero.image + '?alt=media'" [alt]="hero.name" onerror="this.style.display='none'" />
</ng-container>

<div *ngIf="thumbs" class="container-fluid ion-no-padding">
  <div class="row ion-slides">
    <div class="col ion-slide" *ngFor="let image of images, let i=index" (click)="loadImage(image)">
      <img [src]="bucketURL + image.thumb + '?alt=media'" [alt]="image.name" onerror="this.style.display='none'" />
    </div>
  </div>
</div>